import { useTranslation } from 'react-i18next';
import { newCondition } from '../advanced/advancedFilter';
import { AdvancedRow } from '../advanced/AdvancedRow';
import type { IViewFiltersEditorProps } from './IViewFiltersEditorProps';

/** «Фільтри · мають виконуватися всі» подання (прототип v4): рядки «поле · умова · значення · ×» як у розширених фільтрах і «+ Додати фільтр». */
export function ViewFiltersEditor({ ws, rt, filters, onChange }: IViewFiltersEditorProps) {
  const { t } = useTranslation();
  return (
    <div className="lv-vs__field">
      <span className="lv-vs__caption">{t('viewSettings.filters')}</span>
      {filters.length === 0 && <span className="lv-vs__hint">{t('viewSettings.noFilters')}</span>}
      {filters.map((c, i) => (
        <AdvancedRow key={i} ws={ws} rt={rt} condition={c} index={i} onChange={(next) => onChange(filters.map((x, j) => (j === i ? next : x)))}
          onRemove={() => onChange(filters.filter((_, j) => j !== i))} />
      ))}
      <button type="button" className="lv-adv__add" onClick={() => onChange([...filters, newCondition(rt)])}>{t('viewSettings.addFilter')}</button>
    </div>
  );
}
